import {SET_ACTIVE_PAGE} from 'redux/actionType'

export const setActivePage = (page) => {
  return (dispatch) => {
    dispatch({type: SET_ACTIVE_PAGE, data: page})
  }
}
